import { HttpMethod, RequestOptions, useUserRequest } from "../common/lib/fetch";
import { useUser } from "../userAccess/useUser";

export type UpsertSiteUser = {
  email: string;
  role: 'Admin' | 'LimitedAccess';
}

const useUpsertSiteUser = (options?: RequestOptions<void>) => {
  const user = useUser();

  return useUserRequest<UpsertSiteUser, void>({
    path: `/api/sites/${user.selectedSite?.id}/users`,
    method: HttpMethod.POST
  }, options);
}
  
export default useUpsertSiteUser;